import { createProvideInject } from '@collector/shared-ui'

import { AssignPlayerOnPitchConfig } from '../configuration'

export const [
  provideAssignPlayerOnPitchConfig,
  injectAssignPlayerOnPitchConfig,
] = createProvideInject<AssignPlayerOnPitchConfig>('assignPlayerOnPitchConfig')
